import { PROJECT_REVIEW_BASE_URL } from "../../../config/constants";

import { mapLeadershipApiItem } from "./leadership.utils";
import { apiFetch } from "../../../utils/apiClient";

const getAuthHeader = () => {
  const token =
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("authToken") ||
    sessionStorage.getItem("accessToken");

  if (!token) return {};

  const tokenType = sessionStorage.getItem("tokenType") || "Bearer";
  const normalizedToken = String(token).replace(/^"|"$/g, "").replace(/^Bearer\s+/i, "").trim();
  if (!normalizedToken) return {};

  return { Authorization: `${tokenType} ${normalizedToken}` };
};

const getJsonHeaders = () => ({
  "Content-Type": "application/json",
  Accept: "application/json",
  ...getAuthHeader(),
});

export async function fetchLeadershipAttention(
  projectId
) {
  const response = await apiFetch(
    `${PROJECT_REVIEW_BASE_URL}/leadership-attention/${projectId}`,
    {
      method: "GET",
      headers: getJsonHeaders(),
    },
    "Failed to fetch leadership attention items",
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => null);

    throw new Error(
      errorData?.message || "Failed to fetch leadership attention items"
    );
  }

  const data = (await response.json());
  const source = Array.isArray(data.leadershipAttentions)
    ? data.leadershipAttentions
    : [];

  return {
    items: source.map(mapLeadershipApiItem),
    flaggedCount: Number(data.flaggedcount ?? 0),
  };
}
export async function addLeadershipAttention(projectId, descriptions) {
  const response = await apiFetch(`${PROJECT_REVIEW_BASE_URL}/${projectId}/leadership-attention`, {
    method: "POST",
    headers: getJsonHeaders(),
    body: JSON.stringify({ description: descriptions }),
  }, "Failed to save leadership attention items");

  if (!response.ok) {
    throw new Error("Failed to save leadership attention items");
  }
}

export async function updateLeadershipAttention(
  projectId,
  attentionId,
  payload
) {
  const response = await apiFetch(`${PROJECT_REVIEW_BASE_URL}/${projectId}/leadership-attention/${attentionId}`, {
    method: "PATCH",
    headers: getJsonHeaders(),
    body: JSON.stringify(payload),
  }, "Failed to update leadership attention item");

  if (!response.ok) {
    throw new Error("Failed to update leadership attention item");
  }
}

export async function deleteLeadershipAttention(projectId, attentionId) {
  await updateLeadershipAttention(projectId, attentionId, { deleted: true });
}
